<mat-list *ngIf="_addons">
  <mat-divider></mat-divider>
  <ng-container *ngFor="let addon of _addons">
    <mat-list-item (click)="onClick(addon.addonId)">
      <img *ngIf="addon.icon; else noIcon" class="addon-icon" [src]="addon.icon" matListItemAvatar />
      <ng-template #noIcon>
        <mat-icon class="addon-default-icon" matListItemAvatar>add_circle</mat-icon>
      </ng-template>
      <h3 matListItemTitle>{{ addon.title }}</h3>
      <p matListItemLine>{{ addon.tagline }}</p>
      <div *ngIf="showPricing" class="price-section" matListItemMeta>
        <store-pricing
          [pricing]="getDisplayPricing(addon)"
          [highlightPrice]="false"
          [hasVerifiedContract]="_hasVerifiedContract"
          [billedProduct]="billedProductsMap.get(addon.addonId)"
          [loaded]="isBilledProductLoaded(addon)"
        ></store-pricing>
      </div>
    </mat-list-item>
    <mat-divider></mat-divider>
  </ng-container>
</mat-list>
